<template>
  <div>
    <el-tabs tab-position="left">
      <el-tab-pane :label="$t('DisplayPage.wallpaper')">
        <Background/>
      </el-tab-pane>
      <el-tab-pane :label="$t('DisplayPage.theme')">
        <Theme/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Background from "./display/Background";
import Theme from "./display/Theme";

export default {
  name: 'Display',
  components: { Theme, Background},
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
};
</script>
<style lang="less" scoped>

</style>
